import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/components/Commends/Commends.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/components/FaqCard/FaqCard.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/components/TabPrice/TabPrice.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/money.svg");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/ssl.svg");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/visa.png");
